import React from "react";
import { Alert } from "antd";
import ChartCard from "../components/ChartCard";
import RankedProgressBars from "../components/RankedProgressBars";
import { PanelStack } from "../Dashboard.styles";

const roleCountFormatter = (v) => `${v} role${v === 1 ? "" : "s"}`;

// Segment-aware skills breakdown — the callout uses antd `Alert` for an
// inline info/warning note. `skillsData` is the raw /skills API response;
// `segmentLabel`/`segmentDimLabel` are resolved by the caller from the
// active FilterBar selection (e.g. "Human Resources" / "Function").
const TopSkillsPanel = ({ skillsData, segmentLabel, segmentDimLabel }) => {
  if (!skillsData) return null;

  const {
    skills,
    sample_size_roles: roleCount = 0,
    is_directional: isDirectional,
    fallback_used: fallbackUsed,
  } = skillsData;

  const hasSegment = Boolean(segmentLabel) && !fallbackUsed;
  const showFallbackNote = Boolean(segmentLabel) && !hasSegment;

  const title = hasSegment ? `Top Skills — ${segmentLabel}` : "Top 10 Skills — Frequency Chart";
  const subtitle = hasSegment
    ? `Filtered to ${segmentDimLabel}: ${segmentLabel} (${roleCount} role${roleCount === 1 ? "" : "s"} in this run)`
    : "Extracted from job description skill analysis — number of distinct roles requiring each skill";

  return (
    <PanelStack>
      <ChartCard title={title} subtitle={subtitle}>
        <RankedProgressBars
          labels={skills.map((s) => s.skill)}
          values={skills.map((s) => s.mentions)}
          valueFormatter={roleCountFormatter}
          labelWidth={240}
          labelAlign="left"
        />
      </ChartCard>
      {showFallbackNote && (
        <Alert
          type="info"
          showIcon
          message={
            roleCount > 0
              ? `Only ${roleCount} role${roleCount === 1 ? "" : "s"} in this run belong${roleCount === 1 ? "s" : ""} to ${segmentLabel} — too few to show a reliable skills ranking, so this is showing org-wide skills instead.`
              : `No per-segment skills data for ${segmentLabel} yet — showing org-wide skills instead.`
          }
        />
      )}
      {hasSegment && isDirectional && (
        <Alert
          type="warning"
          showIcon
          message={`Small sample (${roleCount} role${roleCount === 1 ? "" : "s"}) — this ranking may not be fully representative.`}
        />
      )}
    </PanelStack>
  );
};

export default TopSkillsPanel;
